import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./userSlice";
import configSlice from "./configSlice";
import applicationSlice from "./applicationSlice";


export const store = configureStore({
    reducer:{
        configSlice,
        userSlice, 
        applicationSlice
    }
});
